export default __webpack_public_path__ + "static/media/clients-02.711bbddf.svg";